<script lang="tsx" setup>
import { computed } from "vue"

import { cleanHTML } from "@/utils/clean"

import ReadMoreText from "@/components/Text/ReadMoreText.vue"

const { html, characters = 500 } = defineProps<{
  html: string
  characters?: number
}>()

const safeHtml = computed(() => cleanHTML(html))
</script>

<template>
  <div>
    <ReadMoreText
      class="lg:hidden body-text-indent"
      :html="safeHtml"
      :characters="characters"
    />
    <div class="hidden lg:block body-text-indent" v-html="safeHtml"></div>
  </div>
</template>
